import React, { useEffect, useState } from 'react';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import DeviceMockupAll from "../assets/Device mockup All.png"
import DeviceMockupTab from "../assets/Device mockup Tab.png"
import DeviceMockupMobile from "../assets/Device mockup mobile.png"
import DeviceMockupLaptop from "../assets/Device mockup Laptop.png"
const ImageSlider = ({ images=[DeviceMockupAll, DeviceMockupTab, DeviceMockupMobile, DeviceMockupLaptop], interval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  const goNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };
  useEffect(() => {
    const autoSlide = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, interval);
    return () => clearInterval(autoSlide);
  }, [images.length, interval]);
  return (
    <div className="relative">
      <div className="flex slider-container">
        <img
          src={images[currentIndex]}
          alt={`Slide ${currentIndex}`}
          className="w-full h-full"
          style={{ objectFit: 'contain' }}
        />
      </div>
      <button onClick={goPrev} className="slider-button slider-button-prev sm:flex">
        <i className="pi pi-chevron-down" style={{ color: '#fff' }}></i>
      </button>
      <button onClick={goNext} className="slider-button slider-button-next sm:flex">
        <i className="pi pi-chevron-down" style={{ color: '#fff' }}></i>
      </button>
     <div className="slider-title">
        <svg xmlns="http://www.w3.org/2000/svg" width={images.length * 18} height="14" viewBox={`0 0 ${images.length * 18} 14`} fill="none">
          {images.map((_, idx) => (
            <circle
              key={idx}
              cx={7 + idx * 18}
              cy="7"
              r={currentIndex === idx ? 7 : 5}
              fill={currentIndex === idx ? "#0C6291" : "#C8C8C8"}
              style={{ cursor: 'pointer' }}
              onClick={() => setCurrentIndex(idx)}
            />
          ))}
        </svg>
      </div>
    </div>
  );
};
export default ImageSlider;